import React, { useEffect } from "react";
import { MapPin, Phone, Instagram, Clock } from "lucide-react";
import { footerInfo, INSTAGRAM_URL } from "../mock";
import { WhatsAppIcon, WHATSAPP_URL } from "../components/WhatsAppButton";

const Contact = () => {
  useEffect(() => window.scrollTo(0, 0), []);
  const { marketedBy } = footerInfo;

  return (
    <main>
      <section className="bg-black text-white py-16 text-center px-4">
        <h1 className="heading-font text-4xl md:text-6xl tracking-wide">CONTACT</h1>
        <p className="text-gray-300 mt-3">We’d love to hear from you.</p>
      </section>

      <section className="max-w-[1100px] mx-auto px-4 md:px-8 py-14 grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* Contact details */}
        <div>
          <h2 className="heading-font text-2xl tracking-wide mb-6">GET IN TOUCH</h2>
          <div className="space-y-5 text-gray-700">
            <div className="flex items-start gap-3">
              <MapPin className="text-[#ED1C24] mt-1" size={20} />
              <div>
                <p className="heading-font">{marketedBy.company}</p>
                {marketedBy.address.map((l) => (
                  <p key={l} className="text-sm text-gray-500">{l}</p>
                ))}
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Phone className="text-[#ED1C24]" size={20} />
              <a href={`tel:${marketedBy.phone.replace(/\s/g, "")}`} className="hover:text-[#ED1C24]">
                {marketedBy.phone}
              </a>
            </div>
            <div className="flex items-center gap-3">
              <Instagram className="text-[#ED1C24]" size={20} />
              <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="hover:text-[#ED1C24]">
                @maximaoils.in
              </a>
            </div>
            <div className="flex items-start gap-3">
              <Clock className="text-[#ED1C24] mt-1" size={20} />
              <div>
                <p className="heading-font">BUSINESS HOURS</p>
                <p className="text-sm text-gray-500">Mon – Sat: 10:00 AM – 7:00 PM</p>
                <p className="text-sm text-gray-500">Sunday: Closed</p>
              </div>
            </div>
          </div>
        </div>

        {/* WhatsApp CTA */}
        <div className="bg-gray-50 border border-gray-100 p-8 flex flex-col items-center justify-center text-center">
          <div className="flex items-center justify-center h-16 w-16 rounded-full bg-[#25D366] text-white mb-5">
            <WhatsAppIcon size={34} />
          </div>
          <h2 className="heading-font text-2xl tracking-wide mb-3">CHAT WITH US</h2>
          <p className="text-gray-600 mb-6 max-w-sm">
            Have a question about products, pricing or dealers? Message us directly on WhatsApp and
            we’ll get back to you quickly.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5b] text-white heading-font tracking-wide px-8 py-3 transition-colors"
          >
            <WhatsAppIcon size={20} /> Message on WhatsApp
          </a>
          <a
            href={`tel:${marketedBy.phone.replace(/\s/g, "")}`}
            className="mt-4 inline-flex items-center gap-2 text-gray-700 hover:text-[#ED1C24] heading-font tracking-wide"
          >
            <Phone size={16} /> {marketedBy.phone}
          </a>
        </div>
      </section>
    </main>
  );
};

export default Contact;
